import React, { useEffect, useState } from "react";
import CardBox from "../common/CardBox";
import { Link } from "react-router-dom";
import {
  Avatar,
  Button,
  Card,
  DatePicker,
  Flex,
  Form,
  GetProp,
  Input,
  Select,
  Space,
  Table,
  TableProps,
  Tag,
  Typography,
  Image,
  Row,
  Col,
  Collapse,
  Radio,
  Upload,
  message,
} from "antd";
import {
  SearchOutlined,
  CloseOutlined,
  PlusOutlined,
  HomeOutlined,
  HomeTwoTone,
  ShopOutlined,
  CoffeeOutlined,
  SwapOutlined,
  MinusOutlined,
  UserOutlined,
  CheckOutlined,
  LockOutlined,
  QuestionOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { ColumnsType, SorterResult } from "antd/es/table/interface";
import qs from "qs";
import CommonDataTable from "../common/CommonDataTable";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus, faUser } from "@fortawesome/free-solid-svg-icons";
import ProfileDetails from "./profileDetail";
import PasswordSettings from "./passwordSettings";
import EmailFlyerDetails from "./emailFlyerDetails";

const { Option } = Select;
interface DataType {
  name: {
    first: string;
    last: string;
  };
  gender: string;
  email: string;
  login: {
    uuid: string;
  };
}

interface TableParams {
  pagination?: any;
  sortField?: SorterResult<any>["field"];
  sortOrder?: SorterResult<any>["order"];
  filters?: Parameters<GetProp<TableProps, "onChange">>[1];
}
const { Title, Text } = Typography;
const columns: ColumnsType<DataType> = [
  {
    title: "Booking Number",
    dataIndex: "booking_number",
    sorter: true,
    render: (booking_number) => `${booking_number}`,
    width: "20%",
  },
  {
    title: "Email",
    dataIndex: "email",
    filters: [
      { text: "Male", value: "male" },
      { text: "Female", value: "female" },
    ],
    width: "20%",
  },
  {
    title: "Customer Name",
    dataIndex: "text",
  },
  {
    title: "Created On",
    dataIndex: "text",
  },
  {
    title: "Booking Status",
    dataIndex: "text",
  },
  {
    title: "",
    dataIndex: "Action",
  },
];

const getRandomuserParams = (params: TableParams) => ({
  results: params.pagination?.pageSize,
  page: params.pagination?.current,
  ...params,
});

const SearchBooking = () => {
  const [form] = Form.useForm();
  const [clientReady, setClientReady] = useState<boolean>(false);

  // To disable submit button at the beginning.
  useEffect(() => {
    setClientReady(true);
  }, []);

  const onFinish = (values: any) => {
    console.log("Finish:", values);
  };
  const [isVisible, setIsVisible] = useState(false);
  return (
    <>
      <Form
        form={form}
        name="search_booking"
        className="search_booking"
        layout="inline"
        onFinish={onFinish}
      >
        <Form.Item
          className="filterTextfieldBox"
          label="Agent/SubAgent Details"
          rules={[
            { required: true, message: "Please input your search keywords!" },
          ]}
        >
          <Select
            className="searchInputField"
            defaultValue="Booking Date"
            options={[
              { value: "All", label: "All" },
              { value: "Agent", label: "Agent" },
              { value: "AGT-0908", label: "AGT-0908" },
              { value: "Sub Agent", label: "Sub Agent" },
            ]}
          />
        </Form.Item>
        <Form.Item
          className="filterTextfieldBox"
          label="Booking Ref. No."
          rules={[{ required: true, message: "Please input your password!" }]}
        >
          <Input className="searchInputField" />
        </Form.Item>
        <Form.Item
          className="filterTextfieldBox"
          label="Service"
          rules={[
            { required: true, message: "Please input your search keywords!" },
          ]}
        >
          <Select
            className="searchInputField"
            defaultValue="Booking Date"
            options={[
              { value: "All", label: "All" },
              { value: "Hotel", label: "Hotel" },
              { value: "Activities", label: "Activities" },
              { value: "Meal", label: "Meal" },
            ]}
          />
        </Form.Item>
        <Form.Item
          className="filterTextfieldBox"
          label="From Date"
          rules={[{ required: true, message: "Please select created from!" }]}
        >
          <DatePicker className="searchInputField" />
        </Form.Item>

        <Form.Item
          className="filterTextfieldBox"
          label="To Date"
          rules={[{ required: true, message: "Please input your password!" }]}
        >
          <DatePicker className="searchInputField" />
        </Form.Item>

        <Form.Item className="d-flex align-end mr-0">
          <Button type="primary" htmlType="submit">
            View Report
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

const BookingData = () => {
  const navigate = useNavigate();

  const onRowClick = (event: any) => {
    navigate("/home/booking/edit");
  };
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  const setAgeSort = () => {
    setSortedInfo({
      order: "descend",
      columnKey: "age",
    });
  };
  const clearFilters = () => {
    setFilteredInfo({});
  };
  const clearAll = () => {
    setFilteredInfo({});
    setSortedInfo({});
  };

  const handleChange = (pagination: any, filters: any, sorter: any) => {
    console.log("Various parameters", pagination, filters, sorter);
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };

  const columns = [
    {
      title: "Booking No.",
      dataIndex: "bookingNo",
      key: "bookingNo",
    },
    {
      title: "Booking Date",
      dataIndex: "bookingDate",
      key: "bookingDate",
    },
    {
      title: "Passenger Name",
      dataIndex: "passengerName",
      key: "passengerName",
    },
    {
      title: "Service",
      dataIndex: "service",
      key: "service",
    },
    {
      title: "Check In",
      dataIndex: "checkIn",
      key: "checkIn",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Agt/Sub",
      dataIndex: "agtSub",
      key: "agtSub",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "View",
      dataIndex: "view",
      key: "view",
    },
  ];

  const data = [
    {
      key: "1",
      bookingNo: "John Brown",
      passengerName: "AGT-900",
      service: "New York No. 1 Lake Park",
      checkIn: "ETMKT980990",
      amount: "Mr. Gharju",
      agtSub: "2",
      status: "0",
      view: "",
    },
    {
      key: "2",
      bookingNo: "John Brown",
      passengerName: "AGT-900",
      service: "New York No. 1 Lake Park",
      checkIn: "ETMKT980990",
      amount: "Mr. Gharju",
      agtSub: "2",
      status: "0",
      view: "",
    },
  ];
  return (
    <>
      <Table
        columns={columns}
        dataSource={data}
        onChange={handleChange}
        className="mt-4"
      />
    </>
  );
};

const text = `
  A dog is a type of domesticated animal.
  Known for its loyalty and faithfulness,
  it can be found as a welcome guest in many households across the world.
`;

export const UserSettings = () => {
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState();
  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </button>
  );

  const getBase64 = (img: any, callback: any) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  };

  const handleChange = (info: any) => {
    if (info.file.status === "uploading") {
      setLoading(true);
      return;
    }
    if (info.file.status === "done") {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, (url: any) => {
        setLoading(false);
        setImageUrl(url);
      });
    }
  };

  const beforeUpload = (file: any) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("Image must smaller than 2MB!");
    }
    return isJpgOrPng && isLt2M;
  };
  const [showForm, setShowForm] = useState(false); // Toggle state

  const handleToggle = () => {
    setShowForm((prev) => !prev);
  };
  const items = [
    {
      key: "1",
      label: (
        <>
          <Title level={4} className="font-weight-400 mt-2 mb-1">
            <Flex align="center" justify="start" gap={12}>
              <div className="iconsbg">
                <FontAwesomeIcon icon={faUser} />
              </div>
              Profile Details
             
            </Flex>
          </Title>
        </>
      ),
      children: (
        <>
          <ProfileDetails showForm={showForm} />
        </>
      ),
    },
    {
      key: "2",
      label: (
        <>
          <Title level={4} className="font-weight-400 mt-2 mb-1">
            <Flex align="center" justify="start" gap={12}>
              <div className="iconsbg">
                <Avatar
                  style={{ backgroundColor: "transparent" }}
                  icon={<LockOutlined />}
                />
              </div>
              Password Settings
            </Flex>
          </Title>
        </>
      ),
      children: (
        <>
          <PasswordSettings />
        </>
      ),
    },
    {
      key: "3",
      label: (
        <>
          <Title level={4} className="font-weight-400 mt-2 mb-1">
            <Flex align="center" justify="start" gap={12}>
              <div className="iconsbg">
                <Avatar
                  style={{ backgroundColor: "transparent" }}
                  icon={<LockOutlined />}
                />
              </div>
              Email Flyer Details
            </Flex>
          </Title>
        </>
      ),
      children: (
        <>
          <EmailFlyerDetails />
        </>
      ),
    },
    {
      key: "3",
      label: (
        <>
          <Title level={4} className="font-weight-400 mt-2 mb-1">
            <Flex align="center" justify="start" gap={12}>
              <div className="iconsbg">
                <Avatar
                  style={{ backgroundColor: "transparent" }}
                  icon={<QuestionOutlined />}
                />
              </div>
              Terms & Conditions in Invoice
            </Flex>
          </Title>
        </>
      ),
      children: <>Your Terms and condition is empty</>,
    },
    {
      key: "4",
      label: (
        <>
          <Title level={4} className="font-weight-400 mt-2 mb-1">
            <Flex align="center" justify="start" gap={12}>
              <div className="iconsbg">
                <Avatar
                  style={{ backgroundColor: "transparent" }}
                  icon={<QuestionOutlined />}
                />
              </div>
              Terms & Conditions in Email Flyer
            </Flex>
          </Title>
        </>
      ),
      children: <>Your Terms and condition is empty</>,
    },
    {
      key: "5",
      label: (
        <>
          <Title level={4} className="font-weight-400 mt-2 mb-1">
            <Flex align="center" justify="start" gap={12}>
              <div className="iconsbg">
                <Avatar
                  style={{ backgroundColor: "transparent" }}
                  icon={<QuestionOutlined />}
                />
              </div>
              Bank Details to be added in Invoice
            </Flex>
          </Title>
        </>
      ),
      children: <>Your Terms and condition is empty</>,
    },
    {
      key: "6",
      label: (
        <>
          <Title level={4} className="font-weight-400 mt-2 mb-1">
            <Flex align="center" justify="start" gap={12}>
              <div className="iconsbg">
                <Avatar
                  style={{ backgroundColor: "transparent" }}
                  icon={<QuestionOutlined />}
                />
              </div>
              Important Information in hotel voucher
            </Flex>
          </Title>
        </>
      ),
      children: <>Your Terms and condition is empty</>,
    },
    {
      key: "7",
      label: (
        <>
          <Title level={4} className="font-weight-400 mt-2 mb-1">
            <Flex align="center" justify="start" gap={12}>
              <div className="iconsbg">
                <Avatar
                  style={{ backgroundColor: "transparent" }}
                  icon={<QuestionOutlined />}
                />
              </div>
              Need Help in Voucher
            </Flex>
          </Title>
        </>
      ),
      children: <>Your Terms and condition is empty</>,
    },
    {
      key: "8",
      label: (
        <>
          <Title level={4} className="font-weight-400 mt-2 mb-1">
            <Flex align="center" justify="start" gap={12}>
              <div className="iconsbg">
                <Avatar
                  style={{ backgroundColor: "transparent" }}
                  icon={<QuestionOutlined />}
                />
              </div>
              Stamp Upload
            </Flex>
          </Title>
        </>
      ),
      children: (
        <>
          <Upload
            name="avatar"
            listType="picture-card"
            className="avatar-uploader"
            showUploadList={false}
            action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
            beforeUpload={beforeUpload}
            onChange={handleChange}
          >
            {imageUrl ? (
              <img
                src={imageUrl}
                alt="avatar"
                style={{
                  width: "100%",
                }}
              />
            ) : (
              uploadButton
            )}
          </Upload>
        </>
      ),
    },
  ];

  const onChange = (key: any) => {
    console.log(key);
  };

  return (
    <div className="p-4">
      <Card className="border-8 border-0 box-shadow">
        <Row>
          <Col xs={12} lg={5}>
            <div className="logo">
              <Image src="assets/images/logo.png" preview={false} />
            </div>
          </Col>
          <Col xs={24} lg={8}>
            <Title level={3} className="font-weight-400 mb-4">
              deepakparwani
            </Title>

            <Tag className="border-0 bg-text font-14 w-100 py-2 mb-3">
              <Flex justify="space-between">
                <span>Credit Limit:</span>
                <span>AED 0.01</span>
              </Flex>
            </Tag>
            <Tag className="border-0 bg-text font-14 w-100 py-2 mb-3">
              <Flex justify="space-between">
                <span>Available Limit:</span>
                <span>AED 0.01</span>
              </Flex>
            </Tag>
            <Tag className="border-0 bg-text font-14 w-100 py-2 mb-3">
              <Flex justify="space-between">
                <span>Credit USED:</span>
                <span>AED 0.01</span>
              </Flex>
            </Tag>
          </Col>
          <Col xs={24} lg={3}></Col>
          <Col xs={24} lg={8}>
            <Title level={3} className="font-weight-400 mb-4">
              R Points
            </Title>

            <Tag className="border-0 bg-text font-14 w-100 py-2 mb-3">
              <Flex justify="space-between">
                <span>EARNED POINTS:</span>
                <span>0</span>
              </Flex>
            </Tag>
            <Tag className="border-0 bg-text font-14 w-100 py-2 mb-3">
              <Flex justify="space-between">
                <span>REDEMEED POINTS:</span>
                <span>0</span>
              </Flex>
            </Tag>
            <Tag className="border-0 bg-text font-14 w-100 py-2 mb-3">
              <Flex justify="space-between">
                <span>AVAILABLE POINTS:</span>
                <span>0</span>
              </Flex>
            </Tag>
          </Col>
        </Row>
      </Card>
      <Card className="border-8 border-0 box-shadow">
        <Collapse
          expandIcon={({ isActive }) =>
            isActive ? <MinusOutlined /> : <PlusOutlined />
          }
          items={items}
          defaultActiveKey={["1"]}
          onChange={onChange}
          expandIconPosition="end"
          className="profile-collapse"
        ></Collapse>
      </Card>
    </div>
  );
};

export default UserSettings;
